import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Plan has free trial ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Monthly Pricing", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Annual Pricing", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row mt-10" }
const _hoisted_10 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_11 = ["data-kt-indicator", "onClick"]
const _hoisted_12 = { class: "indicator-label" }
const _hoisted_13 = { class: "indicator-progress" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormCheckInput = _resolveComponent("FormCheckInput")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_Form, {
        "initial-values": _ctx.formInitialValue,
        "validation-schema": _ctx.formSchema,
        ref: "planForm"
      }, {
        default: _withCtx(({ handleSubmit, values }) => [
          _createElementVNode("form", {
            id: "kt_modal_user_form",
            novalidate: "novalidate",
            onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.handleSubmitForm)), ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FormField, {
                required: true,
                value: values.name,
                formControlClass: "form-control",
                label: "Name",
                showLabel: true,
                name: "name",
                placeholder: "Name",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: true,
                label: "Code",
                name: "code",
                options: _ctx.code,
                selectValue: _ctx.selectedCode,
                type: "multiselect",
                onSelectChange: _ctx.handleChangeCode,
                onSelectCloseOrDeselect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateField('code'))),
                formControlClass: "form-control",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["options", "selectValue", "onSelectChange"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.product_key,
                label: "Product Key",
                showLabel: true,
                name: "product_key",
                placeholder: "Product Key",
                type: "text",
                formControlClass: "form-control",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                modelValue: values.description,
                "onUpdate:modelValue": ($event: any) => ((values.description) = $event),
                options: _ctx.descriptions,
                label: "Description",
                type: "multi-tag",
                showLabel: true,
                required: false,
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"},
                name: "description"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormCheckInput, {
                  modelValue: values.has_free_trial,
                  "onUpdate:modelValue": ($event: any) => ((values.has_free_trial) = $event)
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              (values.has_free_trial)
                ? (_openBlock(), _createBlock(_component_FormField, {
                    key: 0,
                    required: true,
                    value: values.free_trial_days,
                    formControlClass: "form-control",
                    label: "Free Trial Days",
                    showLabel: true,
                    name: "free_trial_days",
                    placeholder: "Free Trial Days",
                    type: "text",
                    containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                    style: {"margin-bottom":"10px!important"}
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormField, {
                required: true,
                value: values.monthly_price,
                formControlClass: "form-control",
                label: "Price",
                showLabel: true,
                name: "monthly_price",
                placeholder: "Price",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: false,
                value: values.monthly_discount,
                formControlClass: "form-control",
                label: "Discount",
                showLabel: true,
                name: "monthly_discount",
                placeholder: "Discount",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.monthly_pricing_key,
                formControlClass: "form-control",
                label: "Monthly Price Key",
                showLabel: true,
                name: "monthly_pricing_key",
                placeholder: "Monthly Price Key",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: false,
                value: values.full_monthly_pricing_key,
                formControlClass: "form-control",
                label: "Full Monthly Price Key",
                showLabel: true,
                name: "full_monthly_pricing_key",
                placeholder: "Full Monthly Price Key",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FormField, {
                required: true,
                value: values.annual_price,
                formControlClass: "form-control",
                label: "Price",
                showLabel: true,
                name: "annual_price",
                placeholder: "Price",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: false,
                value: values.annual_discount,
                formControlClass: "form-control",
                label: "Discount",
                showLabel: true,
                name: "annual_discount",
                placeholder: "Discount",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.annual_pricing_key,
                formControlClass: "form-control",
                label: "Annual Price Key",
                showLabel: true,
                name: "annual_pricing_key",
                placeholder: "Annual Price Key",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: false,
                value: values.full_annual_pricing_key,
                formControlClass: "form-control",
                label: "Full Annual Price Key",
                showLabel: true,
                name: "full_annual_pricing_key",
                placeholder: "Full Annual Price Key",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px!important"}
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-new-design-primary align-self-center w-lg-auto w-100 w-md-auto w-sm-100",
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  onClick: ($event: any) => (_ctx.handleSubmitForm(values))
                }, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.btnText), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.loadingText) + " ", 1),
                    _hoisted_14
                  ])
                ], 8, _hoisted_11)
              ])
            ])
          ], 40, _hoisted_1)
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}